import React, { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import ClientItem from './ClientItem'
import { BrowseContext } from '../../../../contexts/BrowseContext'

export default observer(function ClientsList() {
  const { clients } = useContext(BrowseContext)

  return (
    <div className='overflow-y-auto pr-2 pb-4' style={{ height: 'calc(100vh - 320px)' }}>{ clients.map((client) => <ClientItem key={client.id} client={client} />) }</div>
  )
})
